/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissuerdescription2Inputs */

const en_ticketsissuerdescription2 = /** @type {(inputs: Ticketsissuerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These details appear on the invoices to your buyers.`)
};

const de_ticketsissuerdescription2 = /** @type {(inputs: Ticketsissuerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Angaben stehen auf den Rechnungen an deine Käufer.`)
};

/**
* | output |
* | --- |
* | "These details appear on the invoices to your buyers." |
*
* @param {Ticketsissuerdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuerdescription2 = /** @type {((inputs?: Ticketsissuerdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuerdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuerdescription2(inputs)
	return de_ticketsissuerdescription2(inputs)
});
export { ticketsissuerdescription2 as "ticketsIssuerDescription" }